// deno-lint-ignore-file no-window
/** timer worker block */
export const timerWorkerBlob = new Blob(
  [
    /*js*/ `
      let timerID = null;
      let interval = 10;

      self.onmessage = (e) => {
        if (e.data == "start") {
          timerID = setInterval(() => postMessage("tick"), interval);
        } else if (e.data.interval) {
          interval = e.data.interval;
          if (timerID) {
            clearInterval(timerID);
            timerID = setInterval(() => postMessage("tick"), interval);
          }
        } else if (e.data == "stop") {
          clearInterval(timerID);
          timerID = null;
        }
      };
    `,
  ],
  { type: "text/javascript" }
);

export interface ScheduelerState {
  isPlaying: boolean;
  tempo: number;
  lookahead: number;
  scheduleAheadTime: number;
  nextNoteTime: number;
}

export const ScheduelerInitState: ScheduelerState = {
  tempo: 120.0,
  lookahead: 25.0,
  scheduleAheadTime: 0.1,
  isPlaying: false,
  nextNoteTime: 0.0,
};

export const newSchedueler = (context: AudioContext) => {
  // unmounted el to dispatch events
  const el = document.createElement("div");
  const state: ScheduelerState = { ...ScheduelerInitState };

  const nextNote = () => (state.nextNoteTime += 0.25 * (60.0 / state.tempo));

  const scheduleNote = (time: number) => {
    const tickEvent = new CustomEvent("tick", {
      bubbles: true,
      cancelable: true,
      detail: {
        time: time,
      },
    });
    el.dispatchEvent(tickEvent);
  };

  const scheduler = () => {
    while (state.nextNoteTime < context.currentTime + state.scheduleAheadTime) {
      scheduleNote(state.nextNoteTime);
      nextNote();
    }
  };

  const worker = new Worker(window.URL.createObjectURL(timerWorkerBlob));

  worker.addEventListener("message", (e) => {
    if (e.data == "tick") {
      scheduler();
    } else {
      //
    }
  });

  return {
    start: () => {
      state.isPlaying = true;
      worker.postMessage("start");
    },
    stop: () => {
      state.isPlaying = false;
      worker.postMessage("stop");
    },
    state: () => state,
    el: el,
  };
};
